<div class="button-container">
  <ng-content
    select="ms-speed-reading-footer-button, [ms-speed-reading-footer-button]"
  ></ng-content>
</div>

<!-- <div class="orchestrator">
  <div class="outer-box">
  </div>
</div> -->
